// import React from 'react';
// import Barcode from 'react-barcode';
// import logo from '../assets/logo2.jpg';
// // Assuming you would use a library like 'qrcode.react' for a real QR code
// // For this example, we will use a placeholder or a simple element.
// // import QRCode from 'qrcode.react'; 

// // Use React.forwardRef to allow the parent (OfflineOrderEntry) to attach the labelRef to this component
// const ShippingLabel = React.forwardRef(({ orderDetail, shippingDetail }, ref) => {

//     if (!orderDetail || !shippingDetail) {
//         return <div className="p-4 text-red-600">Error: Order details not provided for label.</div>;
//     }

//     // Helper to get state/country name if available, otherwise return ID or a placeholder
//     const getStateName = (id) => id || 'N/A';
//     const getCountryName = (id) => id || 'N/A';
    
//     // Determine payment method text (Example logic: Assume Prepaid unless explicitly marked COD/Cash)
//     const paymentMethodText = orderDetail.payment_method_id == 1  ? 'COD' : 'PREPAID';

//     const orderDate = new Date(orderDetail.order_date).toLocaleDateString('en-IN', {
//         year: 'numeric', month: 'short', day: 'numeric'
//     });
    
//     // Order Number for Barcode/Display
//     const orderNumber = String(orderDetail.order_number || 'N/A');
//     // Shipment ID
//     const shipmentId = orderDetail.shipment_id || 'N/A';

//     return (
//         <div 
//             ref={ref} 
//             className="bg-white border-2 p-4 border-black" 
//             style={{ 
//                 width: '4in', 
//                 height: '4in', 
//                 boxSizing: 'border-box',
//                 padding: '0.15in', // Small, consistent internal padding
//                 display: 'flex',
//                 flexDirection: 'column',
//                 justifyContent: 'space-between',
//             }}
//         >
            
//             {/* 1. HEADER SECTION (Logo & COD/Prepaid) */}
//             <div className="flex justify-between items-center ml-2 mr-2 mt-2 pb-2 border-b border-gray-400">
//                 {/* LEFT: Logo Placeholder */}
//                 <div className="flex items-center">
//                     <div className=" flex items-center justify-center">
//                         <img src={logo} alt="S"  />
//                     </div>
//                 </div>

//                 {/* RIGHT: COD or PREPAID Text */}
//                 <div className={`text-2xl font-black  p-1 px-3 rounded-md`}>
//                     {paymentMethodText}
//                 </div>
//             </div>

//             {/* 2. ORDER DETAILS & BARCODE SECTION */}
//             <div className="grid grid-cols-3 gap-2 py-3 border-b border-dashed border-gray-400 ml-2 mr-2">
//                 {/* LEFT (Col 1/3): Order Details */}
//                 <div className="col-span-1 text-sm pt-4"> {/* Added pt-4 to align with the center of the barcode */}
//                     <p className="font-bold mb-1">Order No: {orderNumber}</p>
//                     <p className="font-bold  mb-1">Shipment ID: {shipmentId}</p>
//                     <p className="">Date: {orderDate}</p>
//                 </div>
                
//                 {/* RIGHT (Col 2/3): Barcode of Order Number */}
//                 <div className="col-span-2 flex justify-center items-center">
//                      <Barcode
//                         value={orderNumber}
//                         format="CODE128"
//                         // --- BARCODE SIZE INCREASED HERE ---
//                         width={2.8} 
//                         height={95} // Significantly increased height
//                         // ----------------------------------
//                         displayValue={false} 
//                         margin={0}
//                         background="#ffffff"
//                         lineColor="#000000"
//                     />
//                 </div>
//             </div>

//             {/* 3. SHIPPING ADDRESS & QR CODE SECTION (Uses Grid again for two columns) */}
//             <div className="grid grid-cols-3 gap-3 py-3 border-b border-dashed border-gray-400 flex-grow ml-2 mr-2">
//                 {/* LEFT (Col 1/3): Shipping Address (Takes up 2/3rds space) */}
//                 <div className="col-span-2">
//                     <h2 className="text-lg font-black text-gray-800 mb-1">SHIP TO:</h2>
//                     <div className="text-sm leading-tight">
//                         <p className="font-extrabold text-lg">{shippingDetail.customer_name}</p>
//                         <p>{shippingDetail.address_line_1}</p>
//                         {shippingDetail.address_line_2 && <p>{shippingDetail.address_line_2}</p>}
//                         <p>
//                             {shippingDetail.city} - <span className="font-bold">{shippingDetail.pincode}</span>
//                         </p>
//                         <p>
//                             {getStateName(shippingDetail.state_name)}, {getCountryName(shippingDetail.country_name)}
//                         </p>
//                         <p className="mt-1 font-bold text-base">Mobile: {shippingDetail.customer_mobile}</p>
//                     </div>
//                 </div>
                
//                 {/* RIGHT (Col 2/3): QR Code (Takes up 1/3rd space) */}
//                 <div className="col-span-1 flex justify-center items-center">
//                     {/* qrcode */}
//                 </div>
//             </div>
            
//             {/* Optional: SHIP FROM/SOURCE ADDRESS (Kept small to save space) */}
//             <div className="pt-2 ml-2 mr-2">
//                 <h2 className="text-xs font-bold text-gray-700">FROM:</h2>
//                 <div className="text-xs leading-tight">
//                     <p className="font-semibold">KANTHASRI</p>
//                     <p>Ambey Effeciency, BL-1, 3-C, Newtown, 700163</p>
//                 </div>
//             </div>

//             {/* 4. FOOTER SECTION (Disclaimer/Instructions) */}
//             <div className="pt-2 mt-2 border-t border-black text-center text-xs font-bold  bg-red-50 p-1">
//                 <p>PLEASE DO NOT ACCEPT TEMPERED PACKET.</p>
//             </div>
            
//         </div>
//     );
// });

// export default ShippingLabel;
// import React from 'react';
// import Barcode from 'react-barcode';
// import logo from '../assets/logo2.jpg';

// const ShippingLabel = React.forwardRef(({ orderDetail, shippingDetail }, ref) => {
//     if (!orderDetail || !shippingDetail) {
//         return <div className="p-4 text-red-600">Error: Order details not provided for label.</div>;
//     }

//     const getStateName = (id) => id || 'N/A';
//     const getCountryName = (id) => id || 'N/A';
//     const paymentMethodText = orderDetail.payment_method_id == 1 ? 'COD' : 'PREPAID';

//     const orderDate = new Date(orderDetail.order_date).toLocaleDateString('en-IN', {
//         year: 'numeric', month: 'short', day: 'numeric'
//     });
    
//     const orderNumber = String(orderDetail.order_number || 'N/A');
//     const shipmentId = orderDetail.shipment_id || 'N/A';

//     return (
//         <div 
//             ref={ref} 
//             className="print-container bg-white border-[3px] border-black text-black" 
//             style={{ 
//                 width: '4in', 
//                 height: '4in', 
//                 boxSizing: 'border-box',
//                 padding: '0.1in',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 justifyContent: 'space-between',
//                 backgroundColor: 'white',
//                 color: 'black', // Force black text for thermal printers
//                 margin: '0 auto'
//             }}
//         >
//             {/* CSS to ensure crisp printing */}
//             <style dangerouslySetInnerHTML={{ __html: `
//                 @media print {
//                     @page { size: 4in 4in; margin: 0; }
//                     body { margin: 0; -webkit-print-color-adjust: exact; }
//                     .print-container { border: 3px solid black !important; }
//                 }
//             `}} />
            
//             {/* 1. HEADER SECTION */}
//             <div className="flex justify-between items-center px-1 pb-1 border-b-[2px] border-black">
//                 <div className="flex items-center">
//                     <img src={logo} alt="S" style={{ height: '40px', width: 'auto' }} />
//                 </div>
//                 <div className="text-3xl font-black">
//                     {paymentMethodText}
//                 </div>
//             </div>

//             {/* 2. ORDER DETAILS & BARCODE */}
//             <div className="grid grid-cols-10 gap-1 py-2 border-b-[2px] border-dashed border-black">
//                 <div className="col-span-4 text-[10px] leading-tight flex flex-col justify-center">
//                     <p className="font-bold">ORD: {orderNumber}</p>
//                     <p className="font-bold">SID: {shipmentId}</p>
//                     <p>DT: {orderDate}</p>
//                 </div>
//                 <div className="col-span-6 flex justify-end items-center overflow-hidden">
//                      <Barcode
//                         value={orderNumber}
//                         format="CODE128"
//                         width={1.8} // Adjusted for 4in width to prevent clipping
//                         height={60}
//                         displayValue={false} 
//                         margin={0}
//                         lineColor="#000000"
//                     />
//                 </div>
//             </div>

//             {/* 3. SHIPPING ADDRESS */}
//             <div className="py-2 flex-grow">
//                 <h2 className="text-sm font-black mb-1">SHIP TO:</h2>
//                 <div className="text-sm leading-[1.1]">
//                     <p className="font-black text-xl uppercase">{shippingDetail.customer_name}</p>
//                     <p className="font-semibold">{shippingDetail.address_line_1}</p>
//                     {shippingDetail.address_line_2 && <p className="font-semibold">{shippingDetail.address_line_2}</p>}
//                     <p className="text-lg font-black">
//                         {shippingDetail.city} - {shippingDetail.pincode}
//                     </p>
//                     <p className="uppercase">
//                         {getStateName(shippingDetail.state_name)}, {getCountryName(shippingDetail.country_name)}
//                     </p>
//                     <p className="mt-1 font-black text-lg">PH: {shippingDetail.customer_mobile}</p>
//                 </div>
//             </div>
            
//             {/* 4. FROM SECTION */}
//             <div className="pt-1 border-t-2 border-black flex justify-between items-end">
//                 <div className="leading-tight">
//                     <h2 className="text-[10px] font-bold">RETURN IF UNDELIVERED:</h2>
//                     <p className="text-[10px] font-bold uppercase">KANTHASRI</p>
//                     <p className="text-[9px]">Ambey Effeciency, BL-1, 3-C, Newtown, 700163</p>
//                 </div>
//                 {/* Placeholder for small QR if needed */}
//                 <div className="w-12 h-12 bg-gray-200 print:bg-white border border-black flex items-center justify-center text-[8px]">QR</div>
//             </div>

//             {/* 5. FOOTER */}
//             <div className="mt-1 border-2 border-black text-center text-[10px] font-black p-1 uppercase">
//                 DO NOT ACCEPT IF TAMPERED
//             </div>
//         </div>
//     );
// });

// export default ShippingLabel;

import React from 'react';
import Barcode from 'react-barcode';
import logo from '../assets/logo2.jpg';

const ShippingLabel = React.forwardRef(({ orderDetail, shippingDetail }, ref) => {
    if (!orderDetail || !shippingDetail) {
        return <div className="p-4 text-red-600">Error: Order details not provided.</div>;
    }

    const getStateName = (id) => id || 'N/A';
    const getCountryName = (id) => id || 'N/A';
    const paymentMethodText = orderDetail.payment_method_id == 1 ? 'COD' : 'PREPAID';
    const orderDate = new Date(orderDetail.order_date).toLocaleDateString('en-IN', {
        year: 'numeric', month: 'short', day: 'numeric'
    });
    
    const orderNumber = String(orderDetail.order_number || 'N/A');
    const shipmentId = orderDetail.shipment_id || 'N/A';

    return (
        <div className="print-wrapper" style={{ backgroundColor: '#fff' }}>
            <style dangerouslySetInnerHTML={{ __html: `
                @media print {
                    @page { 
                        size: 4in 6in; 
                        margin: 0 !important; 
                    }
                    body { margin: 0 !important; padding: 0 !important; }
                    .print-container { 
                        /* 15px margin applied here */
                        margin: 15px !important; 
                        /* Adjusting width/height to account for the 15px margin on both sides */
                        width: calc(4in - 30px) !important; 
                        height: calc(4in - 30px) !important;
                        border: 2px solid #000 !important;
                        display: flex !important;
                    }
                }
            `}} />

            <div 
                ref={ref} 
                className="print-container bg-white border-2 border-black text-black" 
                style={{ 
                    margin: '15px',
                    width: 'calc(4in - 30px)', 
                    height: 'calc(4in - 30px)', 
                    boxSizing: 'border-box',
                    padding: '10px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    fontFamily: 'sans-serif'
                }}
            >
                {/* 1. HEADER */}
                <div className="flex justify-between items-center mt-4 ml-4 mr-4 pb-2 border-b-2 border-black">
                    <img src={logo} alt="Logo" style={{ height: '45px', width: '150px', maxWidth: '100px' }} />
                    <div className="text-xl font-black px-3 py-1 border-2 border-black">
                        {paymentMethodText}
                    </div>
                </div>

                {/* 2. BARCODE SECTION */}
                <div className="grid grid-cols-12 gap-1 mr-4 py-2 ml-4 border-b-2 border-dashed border-black items-center">
                    <div className="col-span-5 text-[10px] leading-tight font-bold">
                        <p>ORD: {orderNumber}</p>
                        <p>SID: {shipmentId}</p>
                        <p className="font-normal">DT: {orderDate}</p>
                    </div>
                    <div className="col-span-7 flex justify-end">
                         <Barcode
                            value={orderNumber}
                            format="CODE128"
                            width={1.3} // Slightly narrower to guarantee it fits inside the new margins
                            height={45}
                            displayValue={false} 
                            margin={0}
                            lineColor="#000000"
                        />
                    </div>
                </div>

                {/* 3. SHIPPING ADDRESS */}
                <div className="py-2 ml-4 mr-4 flex-grow overflow-hidden">
                    <h2 className="text-[10px] font-black mb-1">SHIP TO:</h2>
                    <div className="leading-tight">
                        <p className="font-black text-lg uppercase mb-1">{shippingDetail.customer_name}</p>
                        <p className="text-[13px] font-semibold">{shippingDetail.address_line_1}</p>
                        {shippingDetail.address_line_2 && <p className="text-[13px] font-semibold">{shippingDetail.address_line_2}</p>}
                        <p className="text-[13px] font-semibold">{shippingDetail.land_mark}</p>
                        <p className="text-lg font-black mt-1">
                            {shippingDetail.city} - {shippingDetail.pincode}
                        </p>
                        <p className="text-[11px] uppercase font-bold">
                            {getStateName(shippingDetail.state_name)}, {getCountryName(shippingDetail.country_name)}
                        </p>
                        <p className="mt-2 font-black text-lg border-t border-black pt-1">
                            PH: {shippingDetail.customer_mobile}
                        </p>
                    </div>
                </div>
                
                {/* 4. FROM & FOOTER */}
                <div className="pt-1 ml-4 mr-4 border-t-2 border-black">
                    <div className="leading-tight">
                        <h2 className="text-[9px] font-bold uppercase">Return Address:</h2>
                        <p className="text-[10px] font-black uppercase">KANTHASRI</p>
                        <p className="text-[9px]">SHOP No:A101, NKDA Market, AD Block, Newtown, 700156</p>
                    </div>
                    <div className="mt-1  text-center text-[10px] font-bold py-1 uppercase">
                        DO NOT ACCEPT IF TAMPERED
                    </div>
                </div>
            </div>
        </div>
    );
});

export default ShippingLabel;